import { isExclusivePronoun, Pronoun } from 'domain/pronouns';
import { Dialects } from 'types/dialects';
import { ProfileType } from 'types/types';
import { ENABLED_EVALUATOR_DIALECTS } from 'variables';

const getEvaluatorDialectsForProfile = (profileType: ProfileType[]) => {
  if (profileType.length === 0) {
    return ENABLED_EVALUATOR_DIALECTS;
  }
  return ENABLED_EVALUATOR_DIALECTS.filter(({ disabledForProfiles }) =>
    profileType.some((type) => !disabledForProfiles.includes(type)),
  );
};

export const getProfileDialectOptions = ({
  selectedPronoun,
  initialPronoun,
  profileTypes,
  profileDialects,
}: {
  selectedPronoun: Pronoun;
  initialPronoun: Pronoun;
  profileTypes: ProfileType[];
  profileDialects: Dialects[];
}) => {
  if (
    !isExclusivePronoun(initialPronoun) &&
    selectedPronoun !== initialPronoun
  ) {
    return getEvaluatorDialectsForProfile(profileTypes);
  }
  if (profileDialects.length) {
    return ENABLED_EVALUATOR_DIALECTS.filter(({ value }) =>
      profileDialects.includes(value as Dialects),
    );
  }
  return ENABLED_EVALUATOR_DIALECTS;
};
